/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { StyledText } from "../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle: string;
}

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px;
  width: 100%;
`;

const textStyle = css`
  text-align: center;
`;

export const EmptyState = ({ title, subtitle, children, ...rest }: Props) => {
  return (
    <div css={wrapperStyle} {...rest}>
      <StyledText css={textStyle} className="bodyTextSemibold mb-0">
        <FontAwesomeIcon icon={solid("info-circle")} />
      </StyledText>
      <StyledText css={textStyle} className="bodyTextSemibold mb-0">
        {title}
      </StyledText>
      <StyledText css={textStyle} className="bodySubtextRegular mb-0">
        {subtitle}
      </StyledText>
      {children}
    </div>
  );
};
